/**
 * Maximum team name limit before truncation / tooltip / summarization.
 */
export const TEAM_NAME_LENGTH_LIMIT = 20;
